import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { fullName, money } from './clientPortalSelectors';
import { billingYears, billingYearLabel } from './clientBillingPresentation';

export default function BillingSummary({ ledger, client, selectedYear, onYear }) {
  const { t: tr, i18n } = useTranslation();
  const [localYear, setLocalYear] = useState('');
  const years = billingYears(ledger);
  const requested = onYear ? selectedYear : localYear;
  const selected = years.find(item => String(item.schoolYearStartYear) === String(requested)) || years[0];
  const ready = ledger && ledger.summary && ledger.summary.assignmentStatus === 'ready';
  const balance = ready && selected ? selected.balanceCents : null;
  const known = Number.isFinite(balance);
  let state = 'paid';
  if (balance < 0) state = 'due';
  if (balance > 0) state = 'credit';
  return (
    <section className="client-portal__card client-portal__billing">
      <p>{tr('client:billing.payer')}: <strong>{fullName(client)}</strong></p>
      <p className="text-muted">{tr('client:billing.payerScope')}</p>
      {known ? (
        <div className="portal-billing__balance">
          <div>
            <h2>{tr(`client:billing.${state}`)}</h2>
            <div className={`portal-billing__amount portal-billing__amount--${state}`}>{money(Math.abs(balance) / 100, i18n.language)}</div>
            <p>{tr('client:billing.year')} {billingYearLabel(selected.schoolYearStartYear)}</p>
          </div>
          {years.length > 1 && (
          <label htmlFor="portal-billing-year">{tr('client:billing.year')}
            <select id="portal-billing-year" className="form-control" value={selected.schoolYearStartYear} onChange={event => (onYear || setLocalYear)(event.target.value)}>
              {years.map(item => <option key={item.schoolYearStartYear} value={item.schoolYearStartYear}>{billingYearLabel(item.schoolYearStartYear)}</option>)}
            </select>
          </label>
          )}
        </div>
      ) : <p role="status">{tr(`client:billing.${ready ? 'noHistory' : 'unavailable'}`)}</p>}
      {known && <p className="portal-billing__note">{tr('client:billing.postedOnly')}</p>}
    </section>
  );
}
BillingSummary.propTypes = { ledger: PropTypes.object, client: PropTypes.object.isRequired, selectedYear: PropTypes.string, onYear: PropTypes.func };
BillingSummary.defaultProps = { ledger: null, selectedYear: '', onYear: null };
